import React from 'react'
import PropTypes from 'prop-types'
import I18n from 'PMT/i18n/I18n'

const Item = ({ item, isSelected, isMainCategory, onClick }) => (
  <div
    onClick={onClick}
    className="pointer backgroundPrimary--hover colorWhite--hover"
    style={{
      height: '40px',
      lineHeight: '40px',
      fontSize: '13pt',
      paddingLeft: '20px',
    }}
  >
    {isMainCategory ? I18n.tr('menu.category.add_item.main_category') : item.name}
  </div>
)

export default Item
